import React from 'react';
import styles from './index.module.scss';

/**
 * LightBlueSubTitlePropsのprops
 */
interface LightBlueSubTitleProps {
  /** 青い縦棒の見出しと説明の配列 */
  label: React.ReactNode;
}

/**
 * LightBlueSubTitle コンポーネント
 */
export const LightBlueSubTitle: React.FC<LightBlueSubTitleProps> = ({
  label,
}) => {
  return (
    <div className={styles['jobSearchDetail-lightBlueSubTitle']}>
      <span>{label}</span>
    </div>
  );
};
